import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { ChevronDown16 } from 'ui/icons/aurora/16px/ChevronDown16';
import { CUSTOM_RANGE } from 'ui/datePicker/helpers';
import { formatDateRange, formatPreset } from '../utils';

const StyledPrefix = styled.span`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

type TriggerProps = {
  onClick: () => void;
  preset: string;
  start: string;
  end: string;
};

export const CustomEventsDateTrigger = ({ onClick, preset, start, end }: TriggerProps) => {
  const label =
    preset && preset === CUSTOM_RANGE ? formatDateRange(preset, start, end) : formatPreset(preset);

  return (
    <>
      <Button
        data-test="trigger"
        onClick={onClick}
        size={BUTTON_SIZES.LARGE}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        <StyledPrefix>Volume</StyledPrefix>
        {label}
        <ChevronDown16 />
      </Button>
    </>
  );
};
